import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import SimpleModal from 'components/SimpleModal';
import Text from 'components/Text';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
function Message(_ref) {
  var uniqueUsers = _ref.uniqueUsers,
    data = _ref.data;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var name = data.name,
    type = data.type,
    assetIds = data.assetIds,
    playlistIds = data.playlistIds;
  var contentCount = type === 'playlist' ? playlistIds === null || playlistIds === void 0 ? void 0 : playlistIds.length : assetIds === null || assetIds === void 0 ? void 0 : assetIds.length;
  if (name) {
    return /*#__PURE__*/_jsxs(Trans, {
      t: t,
      i18nKey: "modal_share_with_users_message_users",
      count: uniqueUsers,
      values: {
        content: name
      },
      children: ["This will share", {
        name: name
      }, " with", {
        uniqueUsers: uniqueUsers
      }, " users."]
    });
  }
  if (type === 'playlist') {
    return /*#__PURE__*/_jsxs(Trans, {
      t: t,
      i18nKey: "modal_share_with_users_message_users_playlist",
      count: uniqueUsers,
      contentCount: contentCount,
      children: ["This will share", {
        contentCount: contentCount
      }, " playlists with", {
        uniqueUsers: uniqueUsers
      }, " users."]
    });
  }
  return /*#__PURE__*/_jsxs(Trans, {
    t: t,
    i18nKey: "modal_share_with_users_message_users_asset",
    count: uniqueUsers,
    contentCount: contentCount,
    children: ["This will share", {
      contentCount: contentCount
    }, " assets with", {
      uniqueUsers: uniqueUsers
    }, " users."]
  });
}
function ConfirmationModal(_ref2) {
  var uniqueUsers = _ref2.uniqueUsers,
    data = _ref2.data,
    onCancel = _ref2.onCancel,
    onConfirm = _ref2.onConfirm;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_jsx(SimpleModal, {
    title: uniqueUsers ? t('modal_share_with_users_title', {
      count: uniqueUsers
    }) : t('modal_share_with_users_title_empty'),
    onClose: onCancel,
    body: uniqueUsers ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "p",
        mb: "s",
        children: /*#__PURE__*/_jsx(Message, {
          uniqueUsers: uniqueUsers,
          data: data
        })
      }), /*#__PURE__*/_jsx("p", {
        children: t('modal_share_with_users_message_proceed')
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("p", {
        children: t('modal_share_with_users_message_no_users')
      }), /*#__PURE__*/_jsx("p", {
        children: t('modal_share_with_users_message_no_users_info')
      })]
    }),
    buttons: [{
      label: t('actions_cancel'),
      onClick: onCancel
    }, {
      variant: 'primary',
      label: t('modal_share_with_users_cta'),
      onClick: onConfirm,
      isDisabled: !uniqueUsers
    }]
  });
}
export default ConfirmationModal;